import { render, staticRenderFns } from "./SsoManager.vue?vue&type=template&id=09981684&scoped=true"
import script from "./SsoManager.vue?vue&type=script&lang=ts"
export * from "./SsoManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09981684",
  null
  
)

export default component.exports